import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
import { css, cx } from "@emotion/css";
import { invisibleCss } from "@snapchat/emotion-helpers";
import { type FC, Fragment, memo } from "react";
import { type TermsContent } from "../hooks/useContentfulApi";
import { StyledContent } from "../styles";

interface EulaContentProps {
    className?: string;
    terms?: TermsContent;
    isLoading: boolean;
}

const TermsTitle: FC<{ title: string; dates: TermsContent["dates"] }> = memo(function TermsTitle({ title, dates }) {
    return (
        <header className={css({ textAlign: "center", paddingBottom: "1em" })}>
            <h1>{title}</h1>
            <p> Effective: {format(parseISO(dates.effectiveDate), "P")}</p>
        </header>
    );
});

export const EulaContent: FC<EulaContentProps> = memo(function EulaContent({ className, terms, isLoading }) {
    return (
        <>
            <StyledContent className={cx(isLoading && invisibleCss, className)}>
                {terms && (
                    <>
                        <TermsTitle title={terms.title} dates={terms.dates} />
                        {terms.sectionsCollection.items.map((item) => (
                            <Fragment key={item.sys.id}>{documentToReactComponents(item.content.json)}</Fragment>
                        ))}
                    </>
                )}
            </StyledContent>
        </>
    );
});
